<template src="./passwordReset.html"></template>

<script>
import { send_passwordMail, save_newPassword } from "@/api/api.account.js";
import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  data: () => ({
    e1: false,
    disabilitaBtn: false,
    alertElaborazione: "",
    tipo: "success",
    reset: false,
    cred: {
      Utente: "",
      Password: "",
      ConfermaPassword: "",
      Code: "",
    },
    OK: false,

    style: {
      maxWidth: "300px",
      maxHeight: "420px",
      marginLeft: "auto",
      marginRight: "auto",
    },
  }),

  methods: {
    sendMail() {
      // Validazione
      if (this.$refs.formPwd.validate() == false) {
        return;
      }

      // Reset
      this.alertElaborazione = "";
      this.disabilitaBtn = true;

      // Invio mail
      send_passwordMail(this.cred)
        .then((res) => {
          this.tipo = "success";
          this.alertElaborazione =
            "Abbiamo inviato un messaggio al tuo indirizzo e-mail con il link per la reimpostazione della password.";

          this.disabilitaBtn = false;
          this.OK = true;
        })
        .catch((err) => {
          console.log("pwdreset.vue " + err);

          this.disabilitaBtn = false;
          this.tipo = "warning";
          this.alertElaborazione = err.response
            ? err.response.data.Message
            : err.message;
        });
    },

    resetPwd() {
      // Validazione
      if (this.$refs.formReset.validate() == false) {
        return;
      }

      // Controllo presenza codice
      if (!this.checkCode()) return;

      // Reset
      this.alertElaborazione = "";
      this.disabilitaBtn = true;

      this.cred.Code = this.$route.query.code;

      // Reset pwd
      save_newPassword(this.cred)
        .then((res) => {
          this.tipo = "success";
          this.alertElaborazione =
            "Operazione completata. Premi il tasto 'Indietro' per tornare al login.";

          this.disabilitaBtn = false;
          this.OK = true;
        })
        .catch((err) => {
          console.log("pwdreset.vue " + err);

          this.disabilitaBtn = false;
          this.tipo = "warning";
          this.alertElaborazione = err.response
            ? err.response.data.Message
            : err.message;
        });
    },

    checkCode() {
      if (this.$route.query.code && this.$route.query.code.length > 0) {
        return true;
      }

      return false;
    },
  },

  mounted() {
    this.reset = this.checkCode();
  },
};
</script>
